@import "../../variables.scss";

.documentation_form {
  &__blank {
    display: none;

    @media (max-width: $size-lg) {
      height: fit-content;
      display: flex;
      width: 100%;
      padding-left: 1rem;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }

    @media (max-width: $size-md) {
      height: 200px;
      display: flex;
      padding: 0 1rem;
      flex-direction: column;
      justify-content: flex-end;
      width: 100%;
    }
  }

  &__hint {
    font-size: 12px;
    white-space: pre-line;
    text-align: left;

    @media (max-width: $size-md) {
      width: 100%;
    }
    @media (max-width: $size-lg) {
      text-align: center;
    }
  }
}

.documentationFiles {
  &__list {
    column-count: 2;
    @media (max-width: $size-md) {
      height: 50vh;
    }
    @media (max-width: $size-lg) {
      column-count: unset;
      overflow: scroll;
    }
  }
}
